module.exports = __webpack_public_path__ + "img/1726035890512-screenshot-1726035747204.png.db496386.webp";